// extracted by mini-css-extract-plugin
export default {"container":"UD-z","dimension":"VD-z","dimensionLabels":"WD-z"};